import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

import axios from 'axios'
Vue.config.productionTip = false
// 引入css
import './assets/static/css/index.css'
import './assets/static/css/style.css'
import './assets/static/js/rem.js'
import './assets/static/font/css/font-awesome.min.css'
import Print from './assets/static/js/print.js'
import Share from 'vue-social-share'

import VueLazyload from 'vue-lazyload'
import moment from 'moment'

import vueAplayer from 'vue-aplayer'
Vue.use(vueAplayer)
// import './assets/static/css/wangEditor-fullscreen-plugin.css'

Vue.use(VueLazyload)

// or with options
Vue.use(VueLazyload, {
  preLoad: 1.3,
  error: 'dist/error.png',
  loading: 'dist/loading.gif',
  attempt: 1
})

Vue.use(Print)
Vue.use(Share)

import APlayer from '@moefe/vue-aplayer'

Vue.use(APlayer, {
  defaultCover: 'https://github.com/u3u.png',
  productionTip: true
})

Vue.prototype.baseURL = 'http://travel.nanyueguyidao.cn/travel-web-boss/'

var Qs = require('qs')
Vue.prototype.$moment = moment //时间格式转换
Vue.prototype.qs = Qs.stringify //qs axios调用接口时用到
Vue.prototype.axios = axios
axios.defaults.baseURL = 'http://travel.nanyueguyidao.cn/travel-web-boss/'
// axios.defaults.baseURL = '/api'
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded'
axios.defaults.timeout = 60000
axios.defaults.withCredentials = true

import { getMyDate, isTelAvailable } from './assets/static/js/util.js'
Vue.prototype.$getMyDate = getMyDate
Vue.prototype.$isTelAvailable = isTelAvailable

import md5 from 'js-md5' //npm install --save js-md5
Vue.prototype.$md5 = md5

Vue.use(ElementUI)
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')

//监听sessionStorage的变化
Vue.prototype.resetSetItem = function(key, newVal) {
  if (key === 'index' || key === 'index_destination') {
    // 创建一个StorageEvent事件
    var newStorageEvent = document.createEvent('StorageEvent')
    const storage = {
      setItem: function(k, val) {
        sessionStorage.setItem(k, val)
        // 初始化创建的事件
        newStorageEvent.initStorageEvent('setItem', false, false, k, null, val, null, null)
        // 派发对象
        window.dispatchEvent(newStorageEvent)
      }
    }
    return storage.setItem(key, newVal)
  }
}

//路由跳转拦截
router.beforeEach((to, from, next) => {
  window.scroll(0, 0) //页面A跳转到页面B，B页面停留在A页面的滚动位置的解决方法
  let UserInformation = localStorage.getItem('token')
  let UserInformation_s = sessionStorage.getItem('token')
  if (to.path != '/traffic') {
    sessionStorage.removeItem('index')
  }
  if (to.path != '/destination') {
    sessionStorage.removeItem('index_destination')
  }
  if (to.meta.authorization) {
    // 判断该路由是否需要登录权限
    if (!UserInformation && !UserInformation_s) {
      next({
        path: '/login',
        query: {
          redirect: to.fullPath
        }
      })
    } else {
      next()
    }
  } else if (to.meta.isLogin) {
    if (UserInformation || UserInformation_s) {
      next({
        path: '/my'
      })
    } else {
      next()
    }
  } else {
    next()
  }
})
// http request 拦截器
axios.interceptors.request.use(
  config => {
    if (localStorage.getItem('token')) {
      config.headers['token'] = localStorage.getItem('token')
    } else {
      config.headers['token'] = sessionStorage.getItem('token')
    }
    return config
  },
  err => {
    return Promise.reject(err)
  }
)

// http response 拦截器
axios.interceptors.response.use(
  response => {
    if (response.data.resultCode == 7) {
      ElementUI.Message.error('用户信息失效，请重新登录')
      localStorage.removeItem('token')
      localStorage.removeItem('userInfoId')
    }
    return response
  },
  error => {
    return Promise.reject(error.response)
  }
)
